import React from 'react';
import { Image } from 'semantic-ui-react';
import './Home.css';

const Home = () => {
    return (
        <div className="ui grid">
            <div className="row">
                <div className="ui centered Big image">
                    <img alt="background" src={require("../images/bg_img_3.jpg")} className="hero-image" />
                </div>
            </div>
            <div className="row profile-section">
                <div className="ui column stackable grid">
                    <div className="three wide column">
                        <Image src={require("../images/profile_img_2.jpg")} size='small' circular className="profile-image" />
                    </div>
                    <div className="nine wide column">
                        <h1 className="name-header animate-slide-right delay-1"><span className="hand-drawn-highlight">José Manuel Vera</span></h1>
                        <em className="titles animate-slide-right delay-2">Data Scientist &#8226; Data Engineer &#8226; Developer &#8226; Industrial Engineer &#8226; Computational Optimization</em>
                        <hr className="divider animate-slide-right delay-3" />
                        <div className="contact-info animate-slide-right delay-4">
                            <p><i className="envelope icon"></i>josemanuel.vera.aray@gmail.com</p>
                            <p>
                                <i className="github icon"></i>
                                <a href="https://github.com/jomavera" target="_blank" rel="noopener noreferrer">github.com/jomavera</a>
                            </p>
                            <p>
                                <i className="linkedin icon"></i>
                                <a href="https://linkedin.com/in/jose-m-vera" target="_blank" rel="noopener noreferrer">linkedin.com/in/jose-m-vera</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;